'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'flower-daffodil';
var width = 512;
var height = 512;
var aliases = [9880];
var unicode = 'f800';
var svgPathData = 'M288 144c0-17.62-14.38-32-32-32s-32 14.38-32 32S238.4 176 256 176S288 161.6 288 144zM495.9 288h-47.26c-69.01 0-134.1 31.62-176.7 86V277.5C284.5 284.4 298.6 288 312.9 288c48.13 0 87.14-39 87.14-87.12c0-20.88-7.501-41.13-21.38-56.88c13.88-15.75 21.38-36 21.38-56.88C400 39 361 0 312.9 0C292 0 271.8 7.5 256 21.38C240.2 7.5 219.1 0 199.1 0C150.1 0 111.1 39 111.1 87.12c0 20.88 7.501 41.12 21.38 56.88C119.5 159.8 111.1 180 111.1 200.9C111.1 249 150.1 288 199.1 288c14.25 0 28.38-3.625 40.88-10.5v96.5C197.5 319.6 132.4 288 63.35 288H16.09C6.962 288-.9142 297.1 .0859 307.7C9.962 422.2 106.4 512 223.9 512h64.26c117.5 0 213.9-89.88 223.8-204.4C512.9 297 505 288 495.9 288zM239.1 480H223.9c-93.89 0-174.7-69.13-190-160l29.5-.0023c67.64 0 130.3 35.38 165 93.38C241.1 436.1 239.1 454 239.1 480zM256 216.4L243.1 233.6C232.9 247.6 216.5 256 199.1 256c-30.38 0-55.13-24.62-55.13-55.12c0-17.38 8.376-33.75 22.38-44L183.6 144l-17.25-12.88C152.4 120.9 143.1 104.5 143.1 87.12C143.1 56.62 168.7 32 199.1 32c17.38 0 33.76 8.375 44.01 22.38L256 71.62l12.88-17.25C279.1 40.38 295.5 32 312.9 32c30.38 0 55.13 24.62 55.13 55.12c0 17.38-8.376 33.75-22.38 43.1L328.4 144l17.25 12.88c14 10.25 22.38 26.62 22.38 44C368 231.4 343.3 256 312.9 256c-17.38 0-33.76-8.375-44.01-22.38L256 216.4zM288 480h-16c0-25.1-2-43.88 11.63-66.63c34.76-58 97.39-93.38 165-93.38L478.2 320C462.8 410.9 382 480 288 480z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFlowerDaffodil = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;